import React, { useEffect, useState } from 'react'

// redux
import { connect } from 'react-redux'

// react toastify
import { toast } from 'react-toastify';

// API
import { addCustomerEmailToAdminStatusApi } from 'utlis/Apis/Notifications_API';

// messages
import {
    UNKNOWN_ERROR_OCCURED,
    ERROR_WHILE__NAME
} from 'utlis/AppMessages/AppMessages'

// includes
import SkeletonLoading from './CopyOfCustomerNotifications__loadingSkeleton'

function CopyOfCustomerNotifications(props) {
    // props
    const {
        loading,
        notificationsData,
        setNotificationsData,

        commonToken,
    } = props

    // states
    const [defaultValue, setDefaultValue] = useState("")
    const [sectionLoading, setSectionLoading] = useState(false)

    // setting notification value
    useEffect(() => {
        if (notificationsData?.forward_customer_email_to_admin) {
            setDefaultValue(notificationsData.forward_customer_email_to_admin)
        }
    }, [notificationsData])

    // function to change the current status 
    const changeStatus = (status) => {
        // btn loading
        setSectionLoading(true)

        // network request
        addCustomerEmailToAdminStatusApi(commonToken, status).then(res => {
            // btn loading
            setSectionLoading(false)

            const resData = res.data

            // if request succesfull
            if (resData && resData.success) {
                setNotificationsData(resData.data) // setting notifications data

                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the success message
                toast.success("Status changed successfully", {
                    autoClose: 2500
                })
            }

            // if request is not succesfull
            if (resData && resData.error) {
                setDefaultValue(notificationsData?.forward_customer_email_to_admin) // if any error chaning the value to default

                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the error message
                toast.error(resData?.message ?? UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500
                })
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} addCustomerEmailToAdminStatusApi `, err.message)

            setDefaultValue(notificationsData?.forward_customer_email_to_admin) // if any error chaning the value to default

            // dismissing all the previous toasts first
            toast.dismiss();

            // showing the error message
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500,
                onClose: () => {
                    // btn loading
                    setSectionLoading(false)
                }
            })
        })
    }

    // on value change
    const handleValueChange = ev => {
        const isChecked = ev.target.checked
        const actualVal = isChecked ? 1 : 0

        setDefaultValue(actualVal) // setting checked value

        changeStatus(actualVal) // chaning in the database
    }

    return (
        <React.Fragment>
            {
                loading ? ( // while loading
                    <div className="page-border-box2 mb-3 mb-md-4 domain-info">
                        <div className="pbb2-inner">
                            <SkeletonLoading />
                        </div>
                    </div>
                ) : (
                    <div className={`page-border-box2 mb-3 mb-md-4 customer-order-notifications ${sectionLoading ? "disabled" : ""}`}>
                        <div className="pbb2-inner d-flex">
                            {/* header */}
                            <div className="app-header-wrapper heading-sm mb-2">
                                <div className="app-heading d-flex mb-2">
                                    <span>Receive copy of all customer notifications</span>
                                    <div className="switch-btn position-relative ms-2" style={{ top: 2.5 }}>
                                        <label className="st-switch-input st-switch-success d-inline-flex align-items-center">
                                            <input
                                                className="d-none"
                                                type="checkbox"
                                                checked={defaultValue}
                                                onChange={handleValueChange}
                                            />
                                            <span className="round-outer">
                                                <span className="round d-block"></span>
                                            </span>
                                        </label>
                                    </div>
                                </div>
                                <p className="app-desc st-fs-14">
                                    With the copies of customer emails, you can track which emails are sent to customers and check that their contents are correct.
                                </p>
                            </div>
                        </div>
                    </div>
                )
            }
        </React.Fragment>
    )
}


const getDataFromStore = state => {
    return {
        commonToken: state.auth.commonToken
    };
}

const dispatchActionsToProps = dispatch => {
    return {
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(CopyOfCustomerNotifications)